const strings = {
  title: 'Nova Interação Auxiliar',
}

export default strings
